import { merge } from '../../helper';

import exLanguage from '../../language';
import * as exTab from '../tab';

import * as exModal from './modal';

// ----------------------------------------------------------------------------

function tabs(config: Record<string, any> = {}): Record<string, any> {
    // Default Config
    const defConfig: Record<string, any> = {
        buttons: [
            {
                html: config.textAction ?? exLanguage.line('general.ok'),
            },
        ],
    };

    // Merge
    merge(defConfig, config);

    // ------------------------------------------------------------------------

    // Create element (modal)
    const modal = exModal.start({
        merge: defConfig,
        destroy: true,
    });

    // ------------------------------------------------------------------------

    // Create element (tab)
    const tab = exTab.create({
        merge: defConfig.tab,
    });
    //
    modal.child(tab.element);

    // ------------------------------------------------------------------------

    // Return
    return modal;
}

// ----------------------------------------------------------------------------

export default tabs;
